import { render, staticRenderFns } from "./AppLoading.vue?vue&type=template&id=4ec9c5c0&"
import script from "./AppLoading.vue?vue&type=script&lang=js&"
export * from "./AppLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports